import "./Footer.css";
import github from "./github.png";
import linkedin from "./linkedin.png";
import gmail from "./gmail.png";
function Footer() {
  return (
    <div className="FooterContainer">
      <div className="FooterFlex">
        <p>Made with ❤️ by Tanisha Rao</p>
        <span>
          {" "}
          <a href="https://github.com/Tanisharao2002">
            <img src={github} className="footerImg" />
          </a>
          {" "}
          <a href="https://www.linkedin.com/in/tanisha911/">
            <img src={linkedin} className="footerImg" />
          </a>
          {" "}
          <a href="mailto:tanisharao810@gmail.com">
            <img src={gmail} className="footerImg" />
          </a>
        </span>
      </div>
    </div>
  );
}

export default Footer;
